﻿/**
 * Footer — scroll to top
 */
(function () {
  function initFooterScrollTop(root) {
    (root || document).querySelectorAll('[data-footer-scroll-top]').forEach(function (btn) {
      if (btn.dataset.footerScrollBound === 'true') return;
      btn.dataset.footerScrollBound = 'true';

      btn.addEventListener('click', function () {
        window.scrollTo({
          top: 0,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initFooterScrollTop(document);
    });
  } else {
    initFooterScrollTop(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) initFooterScrollTop(e.target);
  });
})();
